import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
  Box,
} from '@material-ui/core';
import { Refresh } from '@material-ui/icons';

import { suggestHemisCode } from '../../reducer/hemisCodeSuggest/action';

// prefix — nếu truyền vào (BBKHQT/BBKHTN/BBHNQT/BBHNTN/Sach/TLTN/GT/SVNCKH),
// hiện thêm nút "Gợi ý" tự sinh mã theo format "<prefix>_<khoa>_{yy}.{seq}".
// Không truyền prefix → giữ nguyên hành vi cũ (chỉ nhập tay).
function HemisCodeConfirmModal({
  open,
  onClose,
  onConfirm,
  currentHemisCode = '',
  title = "Xác nhận công trình",
  prefix = null,
  dashboardYear = null,
  departmentId = null,
}) {
  const [hemisCode, setHemisCode] = useState('');
  const [suggestLoading, setSuggestLoading] = useState(false);

  useEffect(() => {
    setHemisCode(currentHemisCode || '');
  }, [currentHemisCode, open]);

  const handleSuggest = async () => {
    if (!prefix || !dashboardYear) return;
    setSuggestLoading(true);
    try {
      const s = await suggestHemisCode(prefix, dashboardYear, departmentId);
      if (s) setHemisCode(s);
    } finally {
      setSuggestLoading(false);
    }
  };

  const handleConfirm = () => {
    onConfirm(hemisCode);
    setHemisCode('');
  };

  const handleClose = () => {
    onClose();
    setHemisCode('');
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} style={{ marginTop: 8 }}>
          <Grid item xs={12}>
            <Box display="flex" gridGap={8} alignItems="flex-start">
              <TextField
                fullWidth
                size="small"
                label="Mã CTKH"
                variant="outlined"
                value={hemisCode}
                disabled={suggestLoading}
                onChange={(e) => setHemisCode(e.target.value)}
                placeholder="Nhập mã CTKH (nếu có)"
              />
              {prefix && (
                <Button
                  size="small"
                  variant="outlined"
                  startIcon={<Refresh />}
                  disabled={suggestLoading || !dashboardYear}
                  onClick={handleSuggest}
                >
                  Gợi ý
                </Button>
              )}
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} size="small">
          Hủy
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="primary"
          size="small"
        >
          Xác nhận
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default HemisCodeConfirmModal;